import { useQuery } from '@tanstack/react-query';
import { getCurrentContext } from '../api/apiCurrentContext';

export const useCurrentContext = () => {
    const { isLoading, error, data } = useQuery({
        queryKey: ['current-context'],
        queryFn: getCurrentContext,
        staleTime: 5 * 60 * 1000, // cache for 5 minutes
    });

    const ctx = data?.data || {};

    return {
        isLoading,
        error,
        currentSchool: ctx.school || null,
        currentYear: ctx.academic_year || null,
        currentTerm: ctx.academic_term || null,
        currentSchoolId: ctx.school?.id || null,
        currentYearId: ctx.academic_year?.id || null,
        currentTermId: ctx.academic_term?.id || null,
    };
};
